(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/javascripts/api-calls.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/javascripts/api-calls.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  rules
} = svs.numbergames;
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const {
  containerStates
} = svs.numbergames.fractiongames.constants;
const {
  hasPassedGenereateEndTime
} = svs.numbergames.fractiongames.utils;
const SYSTEM_TYPES = {
  SYSTEM: 0,
  SINGLE: 1
};
function mapContainer(container) {
  var _container$addonBetAm;
  const {
    rowPrice,
    numbersMaxLength,
    numbersExtraMaxLength
  } = rules.getRules(container.productId);
  const containerState = () => {
    if (container.activatedDrawId) {
      return containerStates.CONTAINER_OPEN;
    }
    if (!hasPassedGenereateEndTime(_objectSpread({
      productNumeric: container.productId
    }, container))) {
      return containerStates.GAME_SOLD_OUT;
    }
    return containerStates.CONTAINER_CLOSED;
  };
  const systemSize = () => container.systemType === SYSTEM_TYPES.SYSTEM ? {
    numbersSize: container.numPrimarySelections,
    extraNumbersSize: container.numSecondarySelections
  } : undefined;
  const rowCount = () => {
    var _container$kenoLevel;
    return container.systemType === SYSTEM_TYPES.SINGLE ? container.numSingleRows : rules.system.generatedRows({
      numbersLength: container.numPrimarySelections,
      numbersExtraLength: container.numSecondarySelections,
      numbersRowSize: (_container$kenoLevel = container.kenoLevel) !== null && _container$kenoLevel !== void 0 ? _container$kenoLevel : numbersMaxLength,
      numbersExtraRowSize: numbersExtraMaxLength
    });
  };
  return {
    containerId: container.containerId,
    activatedDrawId: container.activatedDrawId,
    buyinCloseTime: container.buyinCloseTime,
    stopGenerateMinutes: container.stopGenerateMinutes,
    totalPrice: container.wagerAmount,
    sharePrice: container.wagerSharePrice,
    soldShares: container.soldShares,
    totalShares: container.maxShares,
    productNumeric: container.productId,
    containerState: containerState(),
    game: {
      isSystemBoard: container.systemType === SYSTEM_TYPES.SYSTEM,
      systemSize: systemSize(),
      level: container.kenoLevel,
      hasKungKeno: container.kungKeno,
      rowPrice,
      rowPriceMulti: container.rowPrice / rowPrice,
      rowCount: rowCount(),
      jokerPrice: (_container$addonBetAm = container.addonBetAmount) !== null && _container$addonBetAm !== void 0 ? _container$addonBetAm : 0
    }
  };
}
async function fetchContainers(product) {
  try {
    const {
      response
    } = await drawgamesApiCaller.getMarketplaceContainers({
      product: svs.numbergames.productMapping.getProductName(product)
    });
    return response.containers;
  } catch (error) {
    svs.numbergames.fractiongames.logger.error("Failed to fetch containers for ".concat(product || 'all products'), error);
  }
}
async function fetchActivatedDraw(activatedDrawId) {
  try {
    const {
      response
    } = await drawgamesApiCaller.getMarketplaceActivatedDrawsById({
      activatedDrawId
    });
    return response.activatedDraw;
  } catch (error) {
    svs.numbergames.fractiongames.logger.error("Failed to fetch activatedDraw for ".concat(activatedDrawId), error);
  }
}
Object.assign(svs.numbergames.fractiongames.api_calls, {
  mapContainer,
  fetchContainers,
  fetchActivatedDraw
});

 })(window);